<template>
  <div>
    <Modal
      v-model="show"
      :width="80"
      title="提示"
      @on-visible-change="onVisibleChange"
    >
      <div class="content">
        <header class="text-align_center">
          <Icon type="md-checkmark-circle" size="50" color="#49bc19"></Icon>
          <h2>批量退款发起成功，请耐心等待系统处理结果！</h2>
          <!-- <p class="color-gray">可关闭当前页面，继续操作。</p> -->
        </header>
        <p class="flex align-items" style="margin: 10px 0">
          退款订单总数：<span style="margin-right: 8px; font-weight: bold">{{
            resultInfo.totalRefundOrders
          }}</span>
          已处理退款订单：<span
            class="color-blue"
            style="margin-right: 8px; font-weight: bold"
          >{{ resultInfo.refundOrderProcessed }}</span>
          待处理退款订单：<span
            class="color-red"
            style="margin-right: 8px; font-weight: bold"
          >{{ resultInfo.pendingRefundOrder }}</span>
          处理失败退款订单：<span
            class="color-orange"
            style="margin-right: 8px; font-weight: bold"
          >
            {{ resultInfo.processingFailedRefundOrders }}</span>
          <Spin v-show="loading">
            <Icon
              type="ios-loading"
              size="18"
              class="demo-spin-icon-load"
            ></Icon>
          </Spin>
          <Button style="margin-left:auto;" type="primary" @click="handleExSubmit">下载处理结果</Button>
        </p>
        <div class="table">
          <Table
            :columns="tableColumns"
            :data="tableData"
            :loading="tableLoading"
            border
          >
            <template slot="ordFee" slot-scope="{ row }">
              {{ row.ordFee | showFee }}
            </template>
            <template slot="creationStatus" slot-scope="{ row }">
              <span :class="[creationStatusClassObj[+row.creationStatus]]">{{
                creationStatusInfo[+row.creationStatus]
              }}</span>
            </template>
            <template slot="remark" slot-scope="{ row }">
              <span class="color-red">{{ row.remark }}</span>
            </template>
          </Table>
        </div>
      </div>
      <div class="page-wrap">
        <Page
          :total="pageInfo.total"
          :page-size="pageInfo.pageSize"
          show-sizer
          show-total
          show-elevator
          :page-size-opts="pageSizeOpts"
          :current="pageInfo.pageNum"
          @on-change="handlePageChange"
          @on-page-size-change="onPageSizeChange"
        ></Page>
      </div>
      <div slot="footer">
        <Button type="primary" size="large" @click="show = false">关闭</Button>
      </div>
    </Modal>
    <div>
      <Modal
        v-model="showExportModal"
        title="正在导出"
        :mask-closable="false"
        @on-cancel="handleCancelExport"
      >
        <Progress :percent="percent" :stroke-width="5"></Progress>
        正在导出表格，请给我一些时间，请不要关闭当前页面！
        <div slot="footer">
          <Button @click="handleCancelExport">取消</Button>
        </div>
      </Modal>
    </div>
  </div>

</template>
<script>
import {
  tableColumnsWidth,
  key,
  slot,
  renderFn
} from '@/assets/js/resetTableStyle';
import axios from 'axios';
import { mapMutations } from 'vuex';
import orderCenterApi from '@/request/orderCenter/index.js';
import { downLoadByBlob } from '@/pages/assetsModules/common.js';
import { moneyFenChangeYuan } from '@/utils/utils.js';
let IntervalId;
export default {
  filters: {
    showFee(fee) {
      return moneyFenChangeYuan(fee);
    }
  },
  data() {
    return {
      pageSizeOpts: [10, 20, 50, 100], // 每页条数
      loading: false,
      show: false,
      resultInfo: {
        totalRefundOrders: 0, // 退款订单总数
        refundOrderProcessed: 0, // 已处理退款订单
        pendingRefundOrder: 0, // 待处理退款订单
        processingFailedRefundOrders: 0
      },
      pageInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      tableData: [],
      tableLoading: false,
      tableColumns: [
        key('退款单号', 'insOrderId', tableColumnsWidth.type4),
        key('订单号', 'relOrderId', tableColumnsWidth.type4),
        key('姓名', 'studentName', tableColumnsWidth.type4),
        key('年级班级', 'gradeClassName', tableColumnsWidth.type2),
        key('家长手机号码', 'phoneNo', tableColumnsWidth.type3),
        key('商品名称', 'offerName', tableColumnsWidth.type5),
        key('学期', 'termName', tableColumnsWidth.type3),
        key('提供方', 'orgName', tableColumnsWidth.type4),
        key('上课时间', 'classTimeDesc', tableColumnsWidth.type5),
        slot('申请金额（元）', 'ordFee', tableColumnsWidth.type4),
        key('退款批次ID', 'batchRefundId', tableColumnsWidth.type4),
        slot('审批状态', 'creationStatus', tableColumnsWidth.type2),
        slot('备注', 'failInfo', tableColumnsWidth.type4)
      ],
      creationStatusClassObj: {
        0: 'color-blue',
        1: 'color-green',
        2: 'color-red'
      },
      creationStatusInfo: {
        0: '创建中',
        1: '成功',
        2: '失败'
      }, // 审批状态 0=创建中  1=成功 2=失败
      batchRefundId: '', // 批量退款单ID
      showExportModal: false,
      percent: 0
    };
  },
  methods: {
    ...mapMutations(['DELETE_CACHEROUTE']),
    onVisibleChange(status) {
      if (!status) {
        this.DELETE_CACHEROUTE('orderCenterAfterSaleBatchRefundIndex');
        this.$router.push({
          name: 'orderCenter_afterSale_batchRefundIndex'
          // query: {
          //   reInit: 1
          // }
        });
      }
    },
    handlePageChange(page) {
      this.pageInfo.pageNum = page;
      this.getStatisticsInfo();
      this.getTableInfo();
    },
    onPageSizeChange(size) {
      this.pageInfo.pageSize = size;
      this.pageInfo.pageNum = 1;
      this.getStatisticsInfo();
      this.getTableInfo();
    },
    openModal(batchRefundId) {
      this.batchRefundId = batchRefundId;
      this.reInitData();
      this.show = true;
      this.getStatisticsInfo();
      this.getTableInfo();
    },
    reInitData() {
      this.pageInfo = {
        pageNum: 1,
        pageSize: 10,
        total: 0
      };
      this.tableData = [];
      this.resultInfo = {
        totalRefundOrders: 0, // 退款订单总数
        refundOrderProcessed: 0, // 已处理退款订单
        pendingRefundOrder: 0, // 待处理退款订单
        processingFailedRefundOrders: 0
      };
    },
    // 获取批量退款处理的数据统计
    async getStatisticsInfo() {
      this.loading = true;
      try {
        const res = await orderCenterApi.getCreateMsgByBatchRefundIdStatisticsApi({
          batchRefundId: this.batchRefundId
        });
        if (res.status === 200) {
          Object.keys(this.resultInfo).forEach(item => {
            this.resultInfo[item] = res.message[item];
          });
        }
      } finally {
        this.loading = false;
      }
    },
    // 获取结果表格信息
    async getTableInfo() {
      const params = {
        batchRefundId: this.batchRefundId,
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize
      };
      const res = await orderCenterApi.getCreateMsgByBatchRefundIdApi(params);
      if (res.status === 200) {
        this.tableData = res.message.list;
        this.pageInfo.total = +res.message.total;
      }
    },
    handleCancelExport() {

    },
    // 导出进度条模态框提示
    percentShowFun() {
      this.percent += 20;
      if (this.percent >= 80) {
        clearInterval(IntervalId);
      }
    },
    percentShow() {
      this.percent = 0;
      IntervalId = setInterval(this.percentShowFun, 500);
    },
    // 导出-确定
    async handleExSubmit() {
      const params = {
        batchRefundId: this.batchRefundId
      };
      this.percentShow();
      this.showExportModal = true;
      const CancelToken = axios.CancelToken;
      this.source = CancelToken.source();
      let res = null;
      res = await orderCenterApi.exportCreateMsgByBatchRefundIdApi(
        params,
        this.source.token
      );
      if (res) {
        const reader = new FileReader();
        let resData = null;
        reader.readAsText(res.data, 'utf-8');
        reader.onload = () => {
          if (res.data.type === 'application/vnd.ms-excel') {
            this.$Message.success('导出成功');
            clearInterval(IntervalId);
            this.percent = 100;
            setTimeout(() => {
              this.showExportModal = false;
            }, 500);
            downLoadByBlob(res);
          } else {
            resData = JSON.parse(reader.result);
            clearInterval(IntervalId);
            this.percent = 60;
            setTimeout(() => {
              this.showExportModal = false;
            }, 500);
            this.$Message.error(resData.error);
          }
        };
      } else {
        this.showExportModal = false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>

</style>
